<template>
    <a class="tw-flex tw-justify-end" v-if="roles.is_owner && ! roles.is_public" @click="openModal"><i class="fa fa-pencil"></i></a>
</template>
<script type="text/babel">
    import modalButtonMixin from '../../mixins/modal-button';
    export default {
        name: 'EditButton',
        mixins: [modalButtonMixin],
        props: {
            modalTarget: {type: String, required: true},
            modal: {type: Object, required: false}
        },
    }
</script>
